export default __webpack_public_path__ + "static/media/95_mobile.d8732e51.jpg";